const POPOVER_SELECTOR = '[x-data="popover"]';

/**
 * Marks a region as a right-click zone for the first descendant popover.
 * Dispatches a `popover:open-at-coordinates` event on the popover, which the
 * popover's own listener turns into an `openAtCoordinates` call. Prevents the
 * browser's native context menu and stops the event from bubbling, so nested
 * zones do not both fire — the innermost matching zone wins.
 */
export default (
  el: HTMLElement,
  _meta: unknown,
  { cleanup }: { cleanup: (fn: () => void) => void }
) => {
  const handler = (event: MouseEvent): void => {
    const popoverElement = el.querySelector<HTMLElement>(POPOVER_SELECTOR);
    if (!popoverElement) return;

    event.preventDefault();
    event.stopPropagation();
    popoverElement.dispatchEvent(
      new CustomEvent("popover:open-at-coordinates", {
        detail: { clientX: event.clientX, clientY: event.clientY },
      })
    );
  };

  el.addEventListener("contextmenu", handler);
  cleanup(() => el.removeEventListener("contextmenu", handler));
};
